import { PageLoading } from 'components/loading'
import { useFatoAtividadeColetivaReuniaoQuery } from 'graphql/hooks.generated'
import { Redirect, useParams } from 'react-router'
import { convertFatoAtividadeColetivaReuniaoToAtividadeColetiva } from 'view/atividade-coletiva/converter-atividadeColetiva'

import { AtividadeColetivaVisualizarReuniaoView } from './AtividadeColetivaVisualizarReuniaoView'

interface AtividadeColetivaReuniaoViewParams {
  atividadeColetivaId: ID
}

export function FatoAtividadeColetivaReuniaoView() {
  const { atividadeColetivaId } = useParams<AtividadeColetivaReuniaoViewParams>()

  const {
    data: { fatoAtividadeColetiva },
    loading,
  } = useFatoAtividadeColetivaReuniaoQuery({
    variables: { input: atividadeColetivaId },
  })

  if (loading) {
    return <PageLoading message='Carregando...' />
  } else if (!fatoAtividadeColetiva) {
    return <Redirect to='/404' />
  } else {
    return (
      <AtividadeColetivaVisualizarReuniaoView
        atividadeColetiva={convertFatoAtividadeColetivaReuniaoToAtividadeColetiva(fatoAtividadeColetiva)}
        isFonteDadosPec={false}
      />
    )
  }
}
